import React from 'react';
import StyledButton from "../style";
import {Button} from "@material-ui/core";

function Complete() {
  const CustomStyleButton = StyledButton()
  return (
    <div id='complete'>
      <div className='header'/>
      <div className="content">
        <p className='title'>お申し込み完了</p>
        <div className='group-text'>
          <span>コンソールのお申し込みが完了しました。</span>
          <span>追ってご連絡いたしますので、今しばらくお待ちください。</span>
        </div>
        <div className='group-button'>
          <Button
            variant="contained"
            classes={CustomStyleButton}
            onClick={() => window.location.href = '/register'}
          >
            最初のページに戻る
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Complete;
